import { Trash2 } from "lucide-react";
import type { ChangeEvent } from "react";

import { Input } from "@/app/components/ui/input";
import { Label } from "@/app/components/ui/label";
import { NativeSelect } from "@/app/components/ui/native-select";
import type { PersonalLink } from "@/app/types/resume";

interface LinkInputProps {
	data: PersonalLink;
	setData: (index: number, data: PersonalLink) => void;
	linkOptions: string[];
	deleteLink: () => void;
	index: number;
	error?: string;
}

function LinkInput({ setData, data, linkOptions, deleteLink, index, error }: LinkInputProps) {
	// Fully controlled: read straight from `data` and push edits up through
	// `setData`. No local mirror + write-back effect, which used to ping-pong
	// with the parent and make freshly-loaded values flicker.
	const onChangeType = (e: ChangeEvent<HTMLSelectElement>) => {
		setData(index, { ...data, type: e.target.value });
	};

	const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
		setData(index, { ...data, value: e.target.value });
	};

	return (
		<div className="mb-3 grid grid-cols-3 gap-2">
			<div className="space-y-1">
				<Label htmlFor={`linkType-${index}`} className="text-sm">
					Link Type
				</Label>
				<NativeSelect value={data.type} onChange={onChangeType} id={`linkType-${index}`}>
					<option value="">Select Link Type</option>
					{linkOptions.map((option) => (
						<option key={option} value={option}>
							{option}
						</option>
					))}
				</NativeSelect>
			</div>
			<div className="col-span-2 space-y-1">
				<Label htmlFor={`linkInput-${index}`} className="text-sm">
					Link URL
				</Label>

				<div className="flex items-center gap-2">
					<Input
						type="url"
						id={`linkInput-${index}`}
						value={data.value}
						onChange={onChangeInput}
						placeholder="Enter Url"
					/>
					{data.value.length > 0 && (
						<button
							type="button"
							onClick={deleteLink}
							className="cursor-pointer text-error-default hover:text-error-dark"
							aria-label="Delete link"
						>
							<Trash2 className="size-4" />
						</button>
					)}
				</div>
			</div>
			{error && <p className="col-span-3 text-error-default text-sm">{error}</p>}
		</div>
	);
}

export default LinkInput;
